import { useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function TooltipPortal({
  open,
  anchorEl,
  text,
  className = "",
  maxWidth = "60ch",
  offset = 6,
}) {
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  // Reposition on open/resize/scroll
  const update = () => {
    if (!open || !anchorEl) return;
    const rect = anchorEl.getBoundingClientRect();
    setPos({
      top: rect.bottom + offset + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
  };

  useLayoutEffect(update, [open, anchorEl]); // first paint
  useEffect(() => {
    if (!open) return;
    const onScroll = () => update();
    const onResize = () => update();
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", onResize);
    const id = setInterval(update, 150); // cheap keep-in-sync for layout changes
    return () => {
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onResize);
      clearInterval(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, anchorEl]);

  if (!open || !anchorEl) return null;

  return createPortal(
    <div
      role="tooltip"
      className={
        "z-[9999] pointer-events-none absolute bg-black bg-opacity-90 text-white text-xs rounded py-1 px-2 shadow-lg whitespace-pre-wrap " +
        className
      }
      style={{
        top: pos.top,
        left: pos.left,
        maxWidth,
      }}
    >
      {text}
    </div>,
    document.body
  );
}
